import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
import viewPhoto from 'src/common/js/viewPhoto';
export default {
  mixins: [services],
  data() {
    return {
      DialogVisible: false,
      loading: false,
      title: "查看",
      BabyInfo: {},
      SchoolInfo: {},
      ClassInfo: {},
      CourseInfo: [],
      NetWorkCheckList: [],
      BabyParentList: [],
      BabyAgentInfo: {},
      BabyOrderList: [],
      FollowList: [],
      form: {},
      tabRadio: "网络检测情况"
    }
  },
  methods: {
    initData() {
      this.BabyInfo = {};
      this.SchoolInfo = {};
      this.ClassInfo = {};
      this.CourseInfo = [];
      this.NetWorkCheckList = [];
      this.BabyParentList = [];
      this.BabyAgentInfo = {};
      this.BabyOrderList = [];
      this.FollowList = [];
      this.form = {};
    },
    show(opts) {
      this.initData();
      this.DialogVisible = true;
      this.GetByBabyId(opts.BabyId);
    },
    dialogClose() {
      // 查看关闭
      this.DialogVisible = false
    },
  }

}


// WEBPACK FOOTER //
// ./src/pages/Family/StudentsList/viewDialog/vm.js